import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

if (ENV.MODE === 'production' && ENV.POSTHOG_API_KEY) {
	void import('./utils/consent.ts').then(({ getConsentFromDocument }) => {
		if (getConsentFromDocument() === 'granted') {
			void import('./utils/analytics.client.tsx').then(({ init }) => init())
		}
	})
}

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />)
})
